import script from "./DatePicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatePicker.vue?vue&type=script&setup=true&lang=ts"

import "./DatePicker.vue?vue&type=style&index=0&id=3fc209c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fc209c4"]])

export default __exports__